/**
 * ClinicsList — compact table: sticky column header (desktop) + one
 * ClinicRow per clinic, or the empty state.
 */

import ClinicRow from "./ClinicRow";
import ClinicsEmptyState from "./ClinicsEmptyState";

export const COLUMNS = [
  { key: "clinic", label: "קליניקה" },
  { key: "payment", label: "תשלום" },
  { key: "next", label: "תשלום הבא" },
  { key: "revenue", label: 'סה"כ הכנסות' },
  { key: "contact", label: "קשר אחרון" },
  { key: "login", label: "כניסה אחרונה" },
];

function ClinicsList({
  rows,
  segment,
  filtered,
  usageMap,
  pendingSoByClinic,
  tagMap,
  tags,
  author,
  onOpen,
  onManageTags,
  onReactivate,
}) {
  if (rows.length === 0) {
    return <ClinicsEmptyState segment={segment} filtered={filtered} />;
  }
  const inactive = segment === "inactive";
  return (
    <div className={`nivck2-table${inactive ? " is-inactive" : ""}`} role="table" aria-label="רשימת קליניקות">
      <div className="nivck2-thead" role="row">
        {COLUMNS.map((col) => (
          <span key={col.key} className={`nivck2-th nivck2-th-${col.key}`} role="columnheader">
            {col.label}
          </span>
        ))}
        <span className="nivck2-th nivck2-th-caret" aria-hidden="true" />
      </div>
      <div className="nivck2-list" role="rowgroup">
        {rows.map((row) => (
          <ClinicRow
            key={row.clinicId}
            row={row}
            usage={usageMap[row.clinicId]}
            pendingStandingOrderMonths={pendingSoByClinic[row.clinicId] || 0}
            tagMap={tagMap}
            tags={tags}
            author={author}
            variant={inactive ? "inactive" : "default"}
            onOpen={onOpen}
            onManageTags={onManageTags}
            onReactivate={onReactivate}
          />
        ))}
      </div>
    </div>
  );
}

export default ClinicsList;
